import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { addMediaGroup, deleteAudio, deleteMediaGroup, editMediaGroup, getMediaGroups, getMediaList, getPlayerUrl, } from "@/api/material";
let VideoManage = class VideoManage extends Vue {
    constructor() {
        super(...arguments);
        this.mediaGroups = []; // 视频分组列表
        this._groupCache = null; // 当前操作分组缓存
        this.currentGroupId = 0; // 当前操作分组ID
        this.videoList = []; // 视频列表
        this.isVideoLoading = false; // 视频列表加载状态
        this.search = {
            title: '',
            status: ''
        };
        // 视频列表分页器
        this.videoPaginator = {
            pageNo: 1,
            pageSize: 15,
            total: 0,
        };
        // 视频播放器
        this.videoPlayer = {
            isVisible: false,
            src: "",
        };
    }
    created() {
        this.initGroupData();
        this.getVideoList();
    }
    // 加载分组信息
    async initGroupData() {
        const res = await getMediaGroups(2);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.mediaGroups = [
            // 默认全部视频置顶
            {
                id: 0,
                name: "全部视频",
                _name: "全部视频",
                isEdit: false,
            },
            ...data.map((group) => {
                return {
                    id: group.id,
                    name: group.name,
                    _name: group.name,
                    isEdit: false,
                };
            }),
        ];
    }
    // 新增分组
    handleGroupAdd() {
        this.$prompt("请输入分组名称", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputErrorMessage: "",
            inputValidator(value) {
                // 校验分组名称
                if (value.trim() === '') {
                    return "分组名称不能为空";
                }
                if (value.length > 20) {
                    return "分组名称限制20个字符";
                }
                if (value === "全部视频") {
                    return "不能命名为全部视频";
                }
                return true;
            },
        })
            .then(async (data) => {
            const name = data.value;
            const res = await addMediaGroup(name, 2);
            if (res.data.status !== 200)
                return;
            this.initGroupData();
        })
            .catch(() => {
            // this.$message.info("操作取消");
        });
    }
    // 编辑分组
    handleGroupEdit(group) {
        if (this._groupCache) {
            this._groupCache.isEdit = false;
        }
        group.isEdit = true;
        this._groupCache = group;
    }
    // 保存分组（编辑）
    async handleGroupSave(group) {
        // 【全部视频】分组禁止编辑
        if (group._name === "全部视频") {
            return this.$message.error("不能命名全部视频");
        }
        // 校验分组名称
        if (!group.name) {
            return this.$message.error("分组名称为空");
        }
        if (group.name.length > 20) {
            return this.$message.error("分组名称限制20个字符");
        }
        if (group.name === "全部视频") {
            return this.$message.error("不能命名为全部视频");
        }
        const res = await editMediaGroup(group.id, group.name);
        if (res.data.status !== 200)
            return;
        group.isEdit = false;
        group._name = group.name;
        this._groupCache = null;
    }
    // 删除分组
    handleGroupDelete(group) {
        this.$confirm("此操作将永久删除该分组, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
            .then(async () => {
            const res = await deleteMediaGroup(group.id);
            if (res.data.status !== 200)
                return;
            // 如果当前分组被删除 则跳转到【全部视频】分组
            if (group.id === this.currentGroupId) {
                this.handleGroupClick(0);
            }
            this.initGroupData();
            this.$message.success("删除成功!");
        })
            .catch(() => {
            // this.$message.info("操作取消");
        });
    }
    onSearch() {
        this.videoPaginator.pageNo = 1;
        this.getVideoList();
    }
    // 获取视频列表
    async getVideoList() {
        this.isVideoLoading = true;
        const res = await getMediaList({
            groupId: this.currentGroupId,
            pageNo: this.videoPaginator.pageNo,
            pageSize: this.videoPaginator.pageSize,
            title: this.search.title,
            status: this.search.status,
            type: 2
        });
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.videoList = data.list.map((video) => {
            return {
                id: String(video.id),
                srcId: video.videoId,
                title: video.title,
                cover: video.coverPic,
                duration: video.duration,
                size: video.size,
                addTime: video.delayedTime,
                courseVOS: video.courseVOS || [],
                updateBy: video.updateBy,
                updateTime: video.updateTime,
                status: video.status,
                relativeList: (video.courseVOS &&
                    video.courseVOS.map((course) => {
                        return {
                            id: course.id,
                            name: course.name,
                        };
                    })) ||
                    [],
            };
        });
        this.videoPaginator.total = Number(data.total);
        this.isVideoLoading = false;
    }
    changePageSize(pageSize) {
        this.videoPaginator.pageSize = pageSize;
        this.getVideoList();
    }
    // 视频列表换页
    handleVideoPageChange(pageNo) {
        this.videoPaginator.pageNo = pageNo;
        this.getVideoList();
        // 滚动视频列表置顶再刷新数据
        // scrollTop(
        //   document.getElementsByClassName("app-main")[0],
        //   0,
        //   233,
        //   this.getVideoList
        // );
    }
    // 点击分组
    handleGroupClick(id) {
        if (this.currentGroupId === id)
            return;
        this.currentGroupId = id;
        this.videoPaginator.pageNo = 1;
        this.getVideoList();
        // 滚动视频列表置顶再刷新数据
        // scrollTop(
        //   document.getElementsByClassName("app-main")[0],
        //   0,
        //   233,
        //   this.getVideoList
        // );
    }
    onAdd(props) {
        this.$router.push({ path: '/data-manager/video/edit', query: {
                id: props ? props.id : undefined,
            } });
    }
    // 播放视频（点击视频名片）
    async showVideoPlayer(id) {
        console.log(id);
        const res = await getPlayerUrl(id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        // 校验是否成功获取视频播放地址
        if (!data)
            return this.$message.error("初始化失败");
        this.videoPlayer = {
            isVisible: true,
            src: data,
        };
    }
    // 销毁视频播放器
    destroyVideoPlayer() {
        this.videoPlayer = {
            isVisible: false,
            src: "",
        };
    }
    // 删除视频
    handleVideoDelete(video) {
        if (video.relativeList.length > 0)
            return this.$message.error('该视频已关联课程，需到关联课程将该条视频移除');
        this.$confirm("确定删除该条视频吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            const res = await deleteAudio(video.id);
            if (res.data.status !== 200)
                return;
            this.$message.success("删除成功!");
            this.getVideoList();
        });
    }
    onJump(props) {
        if (props.courseType == 1) {
            // 专栏
            this.$router.push({ path: '/course-manager/columnAdd', query: {
                    id: props.id
                } });
        }
        else {
            // 训练营
            this.$router.push({ path: '/course-manager/termAdd', query: {
                    id: props.id,
                    campId: props.campId
                } });
        }
    }
};
VideoManage = tslib_1.__decorate([
    Component({ name: "VideoManage" })
], VideoManage);
export default VideoManage;
